import { render, staticRenderFns } from "./RemoteModal.vue?vue&type=template&id=c50055aa"
import script from "./RemoteModal.vue?vue&type=script&lang=js"
export * from "./RemoteModal.vue?vue&type=script&lang=js"
import style0 from "./RemoteModal.vue?vue&type=style&index=0&id=c50055aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports